module.exports = __webpack_public_path__ + "static/media/E_SDG_Icons-01.d1bd2c29.jpg";